export * from './comunicaciones.component';
export * from './comunicacion-detail';
export * from './new-comunicacion-dialog';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/comunicaciones/index.ts